<template>
  <div id="app">
    <v-app id="inspire">

      <v-container fluid>

        <v-content>
          <v-layout row wrap>



            <v-flex pa-1 xs12 sm12 md4>
              <v-card class="white--text">
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>

                    <v-layout justify-space-between column>
                      <v-flex xs12 sm12 md12>

                        <v-toolbar flat="" size="120px" dark color="#9E9E9E">

                          <v-toolbar-title> Kişi Bilgileri </v-toolbar-title>
                          <v-spacer></v-spacer>
                        </v-toolbar>
                      </v-flex>
                      <v-text-field hide-details="" autofocus v-model="ManageInfo.UserInfo.AdSoyad" label="Ad Soyad"></v-text-field>
                      <v-text-field hide-details="" :rules="[rules.required, rules.email]" v-model="ManageInfo.UserInfo.Email"
                        label="E-Posta" value="">
                      </v-text-field>
                      <v-text-field hide-details="" v-model="ManageInfo.UserInfo.GSM" label="Cep Telefonu"></v-text-field>
                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>

            </v-flex>


            <v-flex pa-1 xs12 sm12 md8>
              <v-card class="white--text">
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md12>

                        <v-toolbar flat="" size="120px" dark color="#9E9E9E">
                          <v-toolbar-title>Şirket Seçimi </v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-btn @click="listeyeekle()" flat color="white">
                            <span class="hidden-sm-and-down"> Listeye Ekle</span>
                            <v-icon>add</v-icon>

                          </v-btn>
                        </v-toolbar>
                      </v-flex>


                      <v-flex pa-1 xs12 sm6 md4>
                        <v-layout justify-space-between column>
                          <v-select hide-details label="Ana Şirketi Seçiniz" item-value="MusteriKod" persistent-hint
                            :items="AnaSirketler" item-text="MusteriUnvan" v-model="AnaSirket" bottom></v-select>
                          <!-- <referansmerkezicomp></referansmerkezicomp>
                        <masrafmerkezicomp></masrafmerkezicomp>
                        <bolumcomp></bolumcomp> -->
                        </v-layout>
                      </v-flex>

                      <v-flex pa-1 xs12 sm3 md2>
                        <v-layout justify-space-between column>
                          <v-radio-group hide-details v-model="WebUserAnaSirket.UserTip" label="Kullanıcı Tipi" column>
                            <v-radio label="Standart" :value="0"></v-radio>
                            <v-radio label="Admin" :value="1"></v-radio>
                          </v-radio-group>
                        </v-layout>
                      </v-flex>

                      <v-flex pl-2 xs12 sm3 md2>
                        <v-layout justify-space-between column>
                          <v-checkbox hide-details v-model="WebUserAnaSirket.Aktif" label="Aktif"></v-checkbox>
                        </v-layout>
                      </v-flex>
                      <!--
                    <v-flex pa-1 xs12 sm3 md3>
                      <v-layout justify-space-between column>
                        <v-btn @click="listeyeekle()" color="info">
                          <v-icon>add</v-icon>Listeye Ekle
                        </v-btn>
                      </v-layout>
                    </v-flex> -->

                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

            <br />
            <v-layout row wrap>
              <v-flex mt-4 xs12 sm12 md12>

                <v-layout justify-start>
                  <span class=" grey--text headline"> &nbsp; Yetki Verilen Şirketler</span>
                </v-layout>
              </v-flex>
              <v-flex xs6 sm6 md6>
                <v-layout justify-end>

                </v-layout>
              </v-flex>
              <v-flex xs12 sm12 md12>
                <v-layout justify-end>
                  <v-divider></v-divider>
                </v-layout>
              </v-flex>



              <v-layout row wrap>
                <v-flex>
                  <v-list>

                    <template>
                      <v-layout v-show="$vuetify.breakpoint.md || $vuetify.breakpoint.sm || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl "
                        row wrap>
                        <v-flex xs12 sm2 md2>
                          <v-layout column="" align-start>
                            <v-card flat="">
                              <v-list-tile>
                                <v-list-tile-content>
                                  <v-layout align-center>
                                    <v-flex>
                                      <v-list-tile-sub-title>
                                        <v-layout column align-center>
                                          Kullanıcı Tip</v-layout>
                                      </v-list-tile-sub-title>
                                    </v-flex>
                                  </v-layout>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-card>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm2 md2>
                          <v-layout column="" align-start>
                            <v-card flat="">
                              <v-list-tile>
                                <v-list-tile-content>
                                  <v-layout align-center>
                                    <v-flex>
                                      <v-list-tile-sub-title>
                                        <v-layout column align-center>
                                          Kod</v-layout>
                                      </v-list-tile-sub-title>
                                    </v-flex>
                                  </v-layout>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-card>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm4 md4>
                          <v-layout column="" justify-start="" align-start>
                            <v-card flat="">
                              <v-list-tile>
                                <v-list-tile-content>
                                  <v-layout align-center>
                                    <v-flex>
                                      <v-list-tile-sub-title>
                                        <v-layout column align-center>
                                          Ünvan</v-layout>
                                      </v-list-tile-sub-title>
                                    </v-flex>
                                  </v-layout>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-card>
                          </v-layout>
                        </v-flex>



                        <!-- <v-flex xs12 sm4 md2>
                        <v-layout column="" align-start>
                          <v-card flat="">
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-layout align-center>
                                  <v-flex>
                                    <v-list-tile-sub-title>
                                      <v-layout column align-center>
                                        Referans
                                      </v-layout>
                                    </v-list-tile-sub-title>
                                  </v-flex>
                                </v-layout>
                              </v-list-tile-content>
                            </v-list-tile>
                          </v-card>
                        </v-layout>
                      </v-flex>


                      <v-flex xs12 sm4 md2>
                        <v-layout column="" align-start>
                          <v-card flat="">
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-layout align-center>
                                  <v-flex>
                                    <v-list-tile-sub-title>
                                      <v-layout column align-center>
                                        Masraf
                                      </v-layout>
                                    </v-list-tile-sub-title>
                                  </v-flex>
                                </v-layout>
                              </v-list-tile-content>
                            </v-list-tile>
                          </v-card>
                        </v-layout>
                      </v-flex>
                      <v-flex xs12 sm4 md2>
                        <v-layout column="" align-start>
                          <v-card flat="">
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-layout align-center>
                                  <v-flex>
                                    <v-list-tile-sub-title>
                                      <v-layout column align-center>
                                        Bölüm</v-layout>
                                    </v-list-tile-sub-title>
                                  </v-flex>
                                </v-layout>
                              </v-list-tile-content>
                            </v-list-tile>
                          </v-card>
                        </v-layout>
                      </v-flex> -->

                        <v-flex xs12 sm2 md2>
                          <v-layout justify-center="" align-center>
                            <v-card flat="">
                              <v-list-tile>
                                <v-list-tile-content>
                                  <v-layout justify-center="" align-center>
                                    <v-flex>
                                      <v-list-tile-sub-title>
                                        <v-layout column justify-center="" align-center>
                                          Durum
                                        </v-layout>
                                      </v-list-tile-sub-title>
                                    </v-flex>
                                  </v-layout>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-card>
                          </v-layout>
                        </v-flex>


                        <v-flex xs12 sm2 md2>
                          <v-layout justify-end ="" align-end>
                            <v-card flat="">
                              <v-list-tile>
                                <v-list-tile-content>
                                  <v-layout justify-center="" align-center>
                                    <v-flex>
                                      <v-list-tile-sub-title>
                                        <v-layout column justify-end="" align-center>
                                          İşlem
                                        </v-layout>
                                      </v-list-tile-sub-title>
                                    </v-flex>
                                  </v-layout>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-card>
                          </v-layout>
                        </v-flex>




                      </v-layout>
                      <v-divider></v-divider>
                    </template>

                    <template v-for="item in itemseklenen">
                      <v-layout row wrap v-bind:key="item.id">
                        <v-flex v-show="$vuetify.breakpoint.md || $vuetify.breakpoint.sm || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl "
                          xs12 sm2 md2>
                          <v-layout column="" fill-height="" row align-start>
                            <v-card flat="">
                              <v-list-tile>
                                <v-list-tile-content>
                                  <v-layout align-center>
                                    <v-flex>
                                      <v-list-tile-sub-title>
                                        <v-layout column align-center>
                                          <v-chip v-if="item.UserTip=='1'">
                                            <v-avatar class="white--text red">A</v-avatar>
                                            Admin
                                          </v-chip>
                                          <v-chip v-if="item.UserTip=='0'">
                                            <v-avatar class="white--text info">S</v-avatar>
                                            Standart
                                          </v-chip>
                                        </v-layout>
                                      </v-list-tile-sub-title>
                                    </v-flex>
                                  </v-layout>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-card>
                          </v-layout>
                        </v-flex>


                        <v-flex v-show="$vuetify.breakpoint.xs" xs12>
                          <v-layout column="">
                            <v-card flat="">
                              <v-list-tile>
                                <v-layout wrap row justify-center="" align-center>

                                  <v-flex xs6>
                                    <v-list-tile-sub-title>
                                      <v-layout column>
                                        <v-chip v-if="item.UserTip=='1'">
                                          <v-avatar class="white--text red">A</v-avatar>
                                          Admin
                                        </v-chip>

                                        <v-chip v-if="item.UserTip=='0'">
                                          <v-avatar class="white--text info">S</v-avatar>
                                          Standart
                                        </v-chip>

                                      </v-layout>
                                    </v-list-tile-sub-title>
                                  </v-flex>

                                </v-layout>
                              </v-list-tile>
                            </v-card>
                          </v-layout>
                        </v-flex>

                        <v-flex v-show="$vuetify.breakpoint.md || $vuetify.breakpoint.sm || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl "
                          xs6 sm2 md2>
                          <v-layout column="" align-start>
                            <v-card flat="">
                              <v-list-tile>
                                <v-list-tile-content>
                                  <v-layout align-center>
                                    <v-flex>
                                      <v-list-tile-sub-title>
                                        <v-layout column align-center>
                                          {{item.MusteriKod}}
                                        </v-layout>
                                      </v-list-tile-sub-title>
                                    </v-flex>
                                  </v-layout>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-card>
                          </v-layout>
                        </v-flex>

                        <v-flex v-show="$vuetify.breakpoint.xs" xs12>
                          <v-layout column="">
                            <v-card flat="">
                              <v-list-tile>
                                <v-layout row wrap>
                                  <v-flex xs4>
                                   <span class='grey-text--primary body-1'> Müşteri Kodu</span>
                                  </v-flex>
                                  <v-flex xs7>
                                    <v-layout>
                                    <span class='grey-text--primary body-1'> :  {{item.MusteriKod}}</span>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-list-tile>
                            </v-card>
                          </v-layout>
                        </v-flex>

                        <v-flex v-show="$vuetify.breakpoint.md || $vuetify.breakpoint.sm || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl "
                          xs6 sm4 md4>
                          <v-layout column="" align-start>
                            <v-card flat="">
                              <v-list-tile>
                                <v-list-tile-content>
                                  <v-layout align-center>
                                    <v-flex>
                                      <v-list-tile-sub-title>
                                        <v-layout column align-center>
                                          {{item.MusteriUnvan}}</v-layout>
                                      </v-list-tile-sub-title>
                                    </v-flex>
                                  </v-layout>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-card>
                          </v-layout>
                        </v-flex>

                        <v-flex v-show="$vuetify.breakpoint.xs" xs12>
                          <v-layout column="">
                            <v-card flat="">
                              <v-list-tile>
                                <v-layout row wrap>
                                  <v-flex xs4>
                               <span class='grey-text--primary body-1'>     Ünvanı</span>
                                  </v-flex>
                                  <v-flex xs8>
                                       <span class='grey-text--primary body-1'>   : {{item.MusteriUnvan}}</span>
                                  </v-flex>
                                </v-layout>
                              </v-list-tile>

                            </v-card>
                          </v-layout>
                        </v-flex>

                        <!-- <v-flex xs12 sm2 md2>
                        <v-layout column="" align-start>
                          <v-card flat="">
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-layout align-center>
                                  <v-flex>
                                    <v-list-tile-sub-title>
                                      <v-layout column align-center>
                                        {{item.Referans}}
                                      </v-layout>
                                    </v-list-tile-sub-title>
                                  </v-flex>
                                </v-layout>
                              </v-list-tile-content>
                            </v-list-tile>
                          </v-card>
                        </v-layout>
                      </v-flex>


                      <v-flex xs12 sm2 md2>
                        <v-layout column="" align-start>
                          <v-card flat="">
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-layout align-center>
                                  <v-flex>
                                    <v-list-tile-sub-title>
                                      <v-layout column align-center>
                                        {{item.Masraf}}
                                      </v-layout>
                                    </v-list-tile-sub-title>
                                  </v-flex>
                                </v-layout>
                              </v-list-tile-content>
                            </v-list-tile>
                          </v-card>
                        </v-layout>
                      </v-flex>

                      <v-flex xs12 sm2 md2>
                        <v-layout column="" align-start>
                          <v-card flat="">
                            <v-list-tile>
                              <v-list-tile-content>
                                <v-layout align-center>
                                  <v-flex>
                                    <v-list-tile-sub-title>
                                      <v-layout column align-center>
                                        {{item.Bolum}}</v-layout>
                                    </v-list-tile-sub-title>
                                  </v-flex>
                                </v-layout>
                              </v-list-tile-content>
                            </v-list-tile>
                          </v-card>
                        </v-layout>
                      </v-flex> -->

                        <v-flex xs12 sm2 md2>
                          <v-layout align-center justify-center="" row fill-height="">
                            <v-card flat="">
                              <v-list-tile>
                                <v-list-tile-content>
                                  <v-layout row align-center fill-height="">
                                    <v-chip color="green" v-if="item.Aktif==true" text-color="white">
                                      <v-avatar>
                                        <v-icon color="white">check_circle</v-icon>
                                      </v-avatar>
                                      Aktif
                                    </v-chip>
                                    <v-chip color="red" v-if="item.Aktif==false" text-color="white">
                                      <v-avatar>
                                        <v-icon color="white">cancel</v-icon>
                                      </v-avatar>
                                      Pasif
                                    </v-chip>
                                  </v-layout>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-card>
                          </v-layout>
                        </v-flex>


                        <v-flex xs12 sm2 md2>
                          <v-layout justify-end="" align-center row fill-height="">
                            <v-card flat="">
                              <v-list-tile>
                                <v-list-tile-content>
                                  <v-layout row align-center fill-height="" justify-end="">

                                    <v-flex ma-1 xs12 sm12 md12>
                                      <v-btn small icon class="mx-0" @click="listesil(item)">
                                        <v-icon large color="red">delete</v-icon>
                                      </v-btn>
                                    </v-flex>

                                  </v-layout>
                                </v-list-tile-content>
                              </v-list-tile>
                            </v-card>
                          </v-layout>
                        </v-flex>

                      </v-layout>
                      <v-divider :key="item.id"></v-divider>
                    </template>

                  </v-list>
                </v-flex>
              </v-layout>
            </v-layout>



          </v-layout>

        </v-content>


      </v-container>

      <navi v-model="drawer"></navi>


      <v-toolbar color="info" dark app :clipped-left="$vuetify.breakpoint.mdAndUp" fixed>
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>

        <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
          <span>Yeni Kullanıcı</span>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn v-if="kaydetbtn" @click="yenikullanicikaydet('yeni')" flat> <span class="hidden-sm-and-down"> Kaydet
          </span>
        </v-btn>
        <v-btn v-if="guncellebtn" @click="yenikullanicikaydet('guncelle')" flat> <span class="hidden-sm-and-down">
            Kaydet </span>
        </v-btn>
        <v-menu offset-x>
          <v-btn slot="activator" dark icon>
            <v-icon>more_vert</v-icon>
          </v-btn>

          <v-list>
            <a target="_self" v-bind:href="'#/uye/index/'">
              <v-list-tile>
                <v-list-tile-title>İptal</v-list-tile-title>
              </v-list-tile>
            </a>
          </v-list>
        </v-menu>


      </v-toolbar>


      <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
        :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
      </v-snackbar>

    </v-app>
  </div>

</template>

<script>
  import auth from '../../../../api/auth'
  import navi from "@/components/app/account/navigator.vue"
  import axios from 'axios'

  import _ from 'underscore'
  import router from '../../../../router'
  import helpers from "@/components/app/customcomp/helpers.js"
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import bolumcomp from "@/components/app/bilet/partpage/bolumcomp.vue"
  import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue"

  export default {
    data: () => ({
      sirketitems: [],
      detay: false,
      listeleme: true,
      active: null,
      UserInfo: {
        AdSoyad: null,
        Deleted: null,
        Email: null,
        GSM: null,
        KullaniciAdi: null,
        Sifre: null,
        UserID: null
      },
      yetkilist: [],
      listegorunum: true,
      islem: false,


      ManageInfo: {
        UserInfo: {
          UserID: null,
          AdSoyad: null,
          KullaniciAdi: null,
          Email: null,
          GSM: null,
          Sifre: null,
          Deleted: false,
        },
        AnaSirketInfo: []
      },

      WebUserAnaSirket: {
        MusteriID: null,
        MusteriKod: null,
        MusteriUnvan: null,
        UserTip: 0,
        Aktif: false
        // Masraf: null,
        // Referans: null,
        // Bolum: null,
      },

      kaydetbtn: false,
      guncellebtn: false,
      eklebtn: true,
      itemseklenen: [],








      yedekresponse: [],
      bekle: false,
      AnaSirketlerWiev: [],
      AnaSirketler: [],
      Sirketler: [],
      AnaSirket: {},
      Sirket: {},
      giris: true,
      Urunler: false,
      urunlerlist: [],
      active: false,
      sektor: '0',
      uyeliktipi: '0',
      productshow: [],
      odemetipi: false,
      havale: true,
      kredikarti: false,
      odemeekrani: false,
      toplamtutar: 0,
      urunekrani: true,
      musteriid: null,
      dialogyenisirket: false,
      yenisirketunvani: null,
      sirkettipi: '0',
      karttipi: [{
          id: 'M',
          text: 'Master Card'
        },
        {
          id: 'VI',
          text: 'VISA'
        },
        {
          id: 'A',
          text: 'American Express'
        },
      ],
      sonkullanimAy: [{
          id: '01',
          text: '1'
        },
        {
          id: '02',
          text: '2'
        },
        {
          id: '03',
          text: '3'
        },
        {
          id: '04',
          text: '4'
        },
        {
          id: '05',
          text: '5'
        },
        {
          id: '06',
          text: '6'
        },
        {
          id: '07',
          text: '7'
        },
        {
          id: '08',
          text: '8'
        },
        {
          id: '09',
          text: '9'
        },
        {
          id: '10',
          text: '10'
        },
        {
          id: '11',
          text: '11'
        },
        {
          id: '12',
          text: '12'
        }
      ],
      sonkullanimYil: [
        '2005', '2006', '2007', '2008', '2009', '2010', '2011', '2012', '2013', '2014', '2015',
        '2016', '2017',
        '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028',
        '2029', '2030'
      ],
      dictionary: {
        custom: {
          kartno: {
            required: () => 'Bu alan boş bırakılamaz',
            min: 'Kart numarası 16 haneli olmalıdır.'
          },

          selectkarttipi: {
            required: () => 'lütfen seçiminizi yapınız',
          },
          kartcari: {
            required: () => 'lütfen seçiminizi yapınız',
          },
          selectsonkullanim: {
            required: () => 'lütfen seçiminizi yapınız',
          },
          selectsonkullanimyil: {
            required: () => 'lütfen seçiminizi yapınız',
          },

        }
      },

      itemsnavi: [{
          icon: 'business',
          text: 'Şirket İşlemleri',
          to: 'anasirket',
        },
        {
          icon: 'people',
          text: 'Üye İşlemeleri',
          to: 'login-uye'
        },

      ],
      clipped: true,
      drawer: true,
      fixed: false,
      miniVariant: false,
      right: true,
      rightDrawer: false,
      UrunKayit: {
        ID: null,
        MusteriInfo: {
          MusteriID: null,
          MusteriKod: null
        },
        UrunInfo: {
          UrunID: null
        },
        UrunAdet: 1,
        BaslangicTarih: null,
        BitisTarih: null,
        Kontor: null,
        KalanKontor: null,
        SatisTarihi: null,
        SatisTutar: 0,
        Aktif: null,
        OdemeOnay: 'false'
      },

      mevcutsirketmi: true,
      yenisirket: false,
      dialog: false,
      items: [{
          icon: 'domain',
          text: 'Şirket İşlemleri'
        },
        {
          icon: 'contacts',
          text: 'Üye İşlemleri'
        },
      ],


      faturainfo: [],
      newuserstatus: false,
      loginstatus: true,
      drawer: null,
      e1: 0,
      e2: true,
      e3: true,
      e4: true,
      text1: '',
      snackbar: false,
      y: 'top',
      x: 'right',
      mode: '',
      timeout: 6000,
      rules: {
        required: (value) => !!value || 'Gerekli alan.',
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Hatalı e-mail.'
        }
      },
      YeniKullanici: {
        UserID: null,
        MusteriID: 0,
        KullaniciAdi: null,
        Email: null,
        Sifre: null,
        Tip: 0,
        AdSoyad: null,
        Deleted: false,
        Aktif: false,
        MusteriBilgi: [],
        OdemeOnay: false,
      },
      unvan: null,
      confirm: null,
      Credential: {
        email: '',
        password: ''
      },
      valid: true,
      errorMsg: '',
      errorAlert: false,
      AnaSirketler: [],
      Sirketler: [],
      AnaSirket: {},
      Sirket: {}
    }),
    props: {
      source: String
    },
    methods: {
      logout() {
        auth.logout()
      },
      yenikullanicikaydet(islemtipi) {

        var kont = helpers.mailkontrol(this.ManageInfo.UserInfo.Email);

        if (kont == true) {

          if (this.itemseklenen.length > 0) {

            if (this.ManageInfo.UserInfo.AdSoyad != null && this.ManageInfo.UserInfo.Email != null && this.ManageInfo.UserInfo
              .GSM != null) {

              this.ManageInfo.AnaSirketInfo = this.itemseklenen;
              var userparams = this.ManageInfo

              this.$http.post(auth.API_URL + 'api/Register/WebUserManageSave', userparams, {
                headers: {
                  'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
              }).then((response) => {

                if (islemtipi == 'yeni') {

                  this.epostagonder('sifre', this.ManageInfo.UserInfo.Email, response.body.UserToken)

                }


                if (response.body.Status == true) {

                  var url = '#/uye/index'
                  setTimeout(function () {
                    window.open(url, '_self')
                  }.bind(this), 5000)

                }


              }, (response) => {
                if (response.status === 0) {
                  this.text1 = 'Service Unavailable-WebUserManageSave'
                  this.snackbar = true
                } else {
                  this.text1 = 'Service Unavailable-WebUserManageSave'
                  this.snackbar = true
                }
              })

            } else {
              this.text1 = "Lütfen Kişi Bilgilerini Eksiksiz Giriniz"
              this.snackbar = true
            }


          } else {
            this.text1 = "Lütfen listeye yetki verilecek ana şirket yada şirketleri ekleyiniz"
            this.snackbar = true
          }





        } else {
          this.text1 = "Hatalı Email.."
          this.snackbar = true;
        }




      },
      listesil(val) {

        for (var i = 0; i < this.itemseklenen.length; i++) {
          if (this.itemseklenen[i].MusteriKod == val.MusteriKod) {
            this.itemseklenen.splice(i, 1);
          }
        }
      },
      listeyeekle() {
        var kayitvarmi = this.itemseklenen.map(function (e) {
          return e.MusteriKod;
        }).indexOf(this.WebUserAnaSirket.MusteriKod);

        if (this.AnaSirket != null && typeof (this.AnaSirket) != 'object') {
          if (kayitvarmi === -1) {
            var yenikayit = {
              MusteriID: this.WebUserAnaSirket.MusteriID,
              MusteriKod: this.WebUserAnaSirket.MusteriKod,
              MusteriUnvan: this.WebUserAnaSirket.MusteriUnvan,
              UserTip: this.WebUserAnaSirket.UserTip,
              Aktif: this.WebUserAnaSirket.Aktif,
              Masraf: this.WebUserAnaSirket.Masraf,
              Referans: this.WebUserAnaSirket.Referans,
              Bolum: this.WebUserAnaSirket.Bolum
            }
            this.itemseklenen.push(yenikayit)
          } else {
            this.text1 = "Kayıt listede bulunmaktadır."
            this.snackbar = true
          }
        } else {
          this.text1 = "Ana Şirketi Seçiniz"
          this.snackbar = true
        }
      },
      detayagit(val) {
        this.listeleme = false;
        this.detay = true;
        this.UserInfo = val;

        var userparams = {
          Email: val.Email
        }

        this.$http.post(auth.API_URL + 'api/Register/WebUserManageLoad', userparams, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          this.yetkilist = response.body.AnaSirketInfo

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-WebUserManageLoad'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-WebUserManageLoad'
            this.snackbar = true
          }
        })


      },
      epostagonder
    },
    beforeMount: beforeMount,
    components: {
      navi,
      referansmerkezicomp,
      masrafmerkezicomp,
      bolumcomp
    },

    watch: {
      'uyeliktipi': function (value) {
        if (value == 0) {
          this.productshow = [];
          this.urunlerlist.forEach(element => {
            if (element.UrunTip == 2)
              this.productshow.push(element)
          });
        } else {
          this.productshow = [];
          this.urunlerlist.forEach(element => {
            if (element.UrunTip == 3)
              this.productshow.push(element)
          });
        }
      },

      'AnaSirket': function (value) {
        if (value != null) {
          this.AnaSirketler.forEach(element => {
            if (element.MusteriKod == value) {
              this.WebUserAnaSirket.MusteriKod = element.MusteriKod
              this.WebUserAnaSirket.MusteriUnvan = element.MusteriUnvan
              this.WebUserAnaSirket.MusteriID = element.MusteriID
            }
          });
        }
      },
      'sirkettipi': function (value) {
        if (value == '0') {
          this.mevcutsirketmi = true;
          this.yenisirket = false;
          this.dialogyenisirket = false;
        } else {
          this.dialogyenisirket = true;
          this.mevcutsirketmi = false;
          this.yenisirket = true;
        }
      }
    },
    filters: {
      dateformat: function (t) {
        var date = new Date(t);
        var fulldate = date.toLocaleDateString("tr-TR", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
        return fulldate;
      },
      moneyformat: function (m) {
        return m.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      }
    },
  }

  function epostagonder(tip, kime, token) {


    if (tip != 'sifre') {

      var okMail = auth.URL_MAIL + 'isl=confirmmail&email=' + kime + '&&token=' + token +
        ' url adresinden mail adresinizi onaylayabilirsiniz!.'

    } else {
      var okMail = auth.URL_MAIL + 'isl=confirmsifre&email=' + kime + '&&token=' + token +
        ' url adresinden şifrenizi oluşturarak işleminize devam edebilirsiniz!'
    }

    let formData = new FormData();
    formData.append('Konu', 'E-Posta Onay Maili')
    formData.append('to', kime)
    formData.append('formattedMessage', okMail)
    axios.defaults.baseURL = auth.API_URL;
    axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
    axios.post(auth.API_URL + 'api/Helpers/SendEmail',
        formData, {
          headers: {

          }
        }
      ).then((response) => {

        if (response.data == true) {
          this.text1 =
            "Kullanıcı mail adresine onay maili gönderilmiştir. Mailde bulunan link ile şifre oluşturularak işleminize devam edebilirsiniz."
          this.snackbar = true
        } else {
          this.text1 = "Kullanıcı kayıtınız oluşturuldu, onay maili adresinize gönderilemedi."
          this.snackbar = true
        }
      })
      .catch(function () {});

  }

  function beforeMount() {

    //sıralanacak şirketler

    var response2 = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));

    this.AnaSirketler = helpers.yetkilisirketlerigetir(response2.AnaSirketInfo)

    this.kaydetbtn = true;
    this.guncellebtn = false;
  }
</script>